module.exports = __webpack_public_path__ + "img/speaker1.png?31b297059a7db8f9fe083a1df77e93f5";